import React from 'react';
import { connect } from 'react-redux';
import { loadCurrencies } from './currencies.store';
import { getCurrencyStatesWrapper } from '../../util/util';
import { List, Map } from 'immutable';
import { Glyphicon } from 'react-bootstrap';

class CurrencyDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = { show: false };
    this.onClick = this.onClick.bind(this);
  }
  componentWillMount() {
    this.props.loadCurrencies();
    getCurrencyStatesWrapper();
  }
  onClick() {
    this.setState({ show: !this.state.show });
  }
  render() {
    return (this.props.usdData ?
      <div
        className="currency-display"
        onClick={this.onClick}
        style={{ position: 'fixed', right: 0, bottom: 0, zIndex: 1,
          border: 'thin solid lightgray',
          borderRadius: this.state.show ? 10 : 0, padding: 2,
          background: 'rgba(200, 200, 200, 0.2)' }}
      >
        {this.state.show ?
          <div>
        USD rates for
            <br />
            {this.props.usdData.get('date', '')}:
            {this.props.usdData.get('rates', new List())
              .filter(r => r.get('currency') !== 'USD'
                && this.props.currencies.find(cs => cs.get('currency') === r.get('currency'),
                  this, new Map()).get('state'))
              .map((r, idx) => <div key={idx}>{r.get('currency')}:
                {r.get('rate', 0).toFixed(4)}</div>)}
          </div>
          :
          <Glyphicon glyph="usd" style={{ padding: '5px 1px 0 0' }} />
        }
      </div>
      : '');
  }
}
CurrencyDisplay.propTypes = {
  loadCurrencies: React.PropTypes.func,
  usdData: React.PropTypes.object,
  currencies: React.PropTypes.object,
};

export default connect((state) => ({
  usdData: state.getIn(['data', 'currencies', 'USD'], new Map()),
  currencies: state.getIn(['data', 'currencies', 'states'], new List()),
}), (dispatch) => ({
  loadCurrencies() {
    loadCurrencies(dispatch);
  },
}))(CurrencyDisplay);
